import "bootstrap/dist/js/bootstrap.bundle";
import "owl.carousel2";
import "./animations/_animations";
import "jquery-match-height"
import "./modernizr"
import "@fancyapps/fancybox";
import "./Vue/index";
import {WooComm} from "./woocommerce/index";
import "../../../../plugins/woocommerce/assets/js/jquery-blockui/jquery.blockUI";
import "./woocommerce/product-single"
import "./_product-single";
import "./_navigation";
import "./_readmore";
import "./_video-control";
import "./_bottle-basics";
import "./_neck-know-how";
// import "./_ga";
// import "./_GoogleMaps";
// import OffCanvasNavbar from "./OffCanvasNavbar";

const woo = new WooComm();
woo.runEvents();

jQuery(window).on('resize load', function() {
    // var currenHeight = jQuery('.hero--home').height();
    var winHeight = jQuery(window).height();
    var navHeight = jQuery('#header--site').height();
    // this.console.log(winHeight);

    var newHeight = parseFloat(winHeight - navHeight);

    jQuery('.hero--home').height(newHeight)
});

if (window.hasOwnProperty("boxSettings")) {
    const contentExplorer = new Box.ContentExplorer();
    contentExplorer.show( boxSettings.FOLDER_ID, boxSettings.ACCESS_TOKEN, {
        container : "#boxExplorer",
        canDelete : false,
        canRename : false,
        canCreateNewFolder : false,
        canUpload : false,
        canShare : false,
        logoUrl : boxSettings.LOGO_URI
    });
}

jQuery(document).on('found_variation', (e, variation) => {
    if (variation.hasOwnProperty('attributes')) {
        let attributes = variation.attributes;
        if (attributes.hasOwnProperty('attribute_pa_us-or-eu')) {
            let region = attributes['attribute_pa_us-or-eu']
            if (region && window.hasOwnProperty('TG') && TG.hasOwnProperty('catalog')) {
                let catalog = TG.catalog.split('-').pop()
                
                if (catalog !== region) {
                    jQuery('.single_add_to_cart_button').attr('disabled', 'disabled').addClass('disabled')
                }
            }
        }
    }
})

const $homeSlider = jQuery('.hero--slider .owl-carousel')
if ($homeSlider) {
  $homeSlider.owlCarousel({
    items: 1,
    dots: true,
    autoplay: true,
    // autoplayHoverPause: true,
    loop: true
  })
}
